import { Auth, AuthType } from '@/type';
import { Credentials, CredentialsProvider } from './types';
import { requestLogin } from '../type/login';

const provider:CredentialsProvider = {
  supports(platform: string, auth:Auth): boolean {
    return (auth.type === AuthType.LOGIN);
  },
  async getCredentials(
    platform: string,
    auth:Auth,
    permissions: string[],
  ): Promise<Credentials|null> {
    const sessionId = await requestLogin(platform);
    return (sessionId === null) ? null : { sessionId };
  },
};

export default provider;
